(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["senaya-back-to-top"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-senaya-back-to-top]';

    const ensureAboutLink = () => {
      const list = document.querySelector('.senaya-footer nav[aria-label="Boutique"] .senaya-footer__links');
      if (!list || list.querySelector('[data-senaya-about-footer]')) return;

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '/pages/a-propos';
      link.textContent = 'À propos';
      link.dataset.senayaAboutFooter = 'true';
      item.appendChild(link);
      list.prepend(item);
    };

    const initialize = (button) => {
      if (button.dataset.senayaInitialized === 'true') return;

      button.dataset.senayaInitialized = 'true';
      button.hidden = false;

      const updateVisibility = () => {
        button.classList.toggle('is-visible', window.scrollY > 400);
      };

      button.addEventListener('click', () => {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });

      window.addEventListener('scroll', updateVisibility, { passive: true });
      updateVisibility();
    };

    document.querySelectorAll(selector).forEach(initialize);
    ensureAboutLink();

    document.addEventListener('shopify:section:load', () => {
      document.querySelectorAll(selector).forEach(initialize);
      ensureAboutLink();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
